/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIStorageArticleRequest
 */
export interface APIStorageArticleRequest {
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleRequest
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleRequest
     */
    position: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleRequest
     */
    article: string;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleRequest
     */
    sharedRequest?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIStorageArticleRequest
     */
    guestRequest?: string | null;
}

/**
 * Check if a given object implements the APIStorageArticleRequest interface.
 */
export function instanceOfAPIStorageArticleRequest(value: object): value is APIStorageArticleRequest {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    return true;
}

export function APIStorageArticleRequestFromJSON(json: any): APIStorageArticleRequest {
    return APIStorageArticleRequestFromJSONTyped(json, false);
}

export function APIStorageArticleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStorageArticleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'position': json['position'],
        'article': json['article'],
        'sharedRequest': json['shared_request'] == null ? undefined : json['shared_request'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
    };
}

export function APIStorageArticleRequestToJSON(value?: APIStorageArticleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'comment': value['comment'],
        'position': value['position'],
        'article': value['article'],
        'shared_request': value['sharedRequest'],
        'guest_request': value['guestRequest'],
    };
}

